import { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { RxCross1 } from "react-icons/rx";
import { useFormik } from "formik";
import * as Yup from "yup";
import SelectInput from "../SelectInput/SelectInput";
import { HttpService } from "../../service/HttpService";
import { useAuth } from "../../context/AuthProvider";

const AddBucketModal = ({ open, onClose, editData, fetchBuckets }) => {
  const { setShowLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [roomOptions, setRoomOptions] = useState([]);

  const epicenterOptions = [
    { id: "E1", name: "E1" },
    { id: "E2", name: "E2" },
    { id: "E3", name: "E3" },
  ];

  const validationSchema = Yup.object({
    roomId: Yup.mixed().required("Room is required"),
    epicenter: Yup.string().trim().required("Epicenter is required"),
    number: Yup.number()
      .typeError("Enter a valid number")
      .integer("Must be an integer")
      .min(1, "Minimum 1")
      .required("Number of buckets is required"),
  });

  const formik = useFormik({
    initialValues: {
      roomId: editData?.roomId || "",
      epicenter: editData?.epicenter || "",
      number: editData ? String(editData?.number || 1) : "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        const payload = {
          room_id: values.roomId,
          epicenter: values.epicenter,
          totalBuckets: Number(values.number),
        };
        await httpService.post("bucket", payload);
        if (typeof fetchBuckets === "function") {
          fetchBuckets();
        }
        formik.resetForm();
        onClose();
      } catch (e) {
        // optionally handle toast here
      }
    },
  });

  const fetchRooms = async () => {
    try {
      const res = await httpService.get("rooms");
      const list = res?.data?.data || res?.data || [];
      const options = Array.isArray(list)
        ? list.map((item) => ({ id: item?.id, name: item?.name }))
        : [];
      setRoomOptions(options);
    } catch (e) {
      setRoomOptions([]);
    }
  };

  useEffect(() => {
    if (open) {
      fetchRooms();
    }
  }, [open]);

  return (
    <>
      <Modal
        className="department-modal"
        open={open}
        onClose={() => {
          formik.resetForm();
          onClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="modal_block">
            <div className="modal_header">
              <div className="modal_title_wrapper">
                <h2 className="modal_title">
                  {editData ? "Edit Bucket ID" : "Add Bucket ID"}
                </h2>
              </div>
              <div className="cancel-btn-wrap">
                <RxCross1
                  onClick={() => {
                    formik.resetForm();
                    onClose();
                  }}
                />
              </div>
            </div>

            <div className="modal_content">
              <div className="row">
                <div className="col-md-6">
                  <SelectInput
                    label={"Room"}
                    name="roomId"
                    required={true}
                    value={formik.values.roomId}
                    multiple={false}
                    onBlur={formik.handleBlur}
                    options={roomOptions}
                    error={formik.touched.roomId && formik.errors.roomId}
                    onChange={(event) => {
                      formik.setFieldValue("roomId", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <SelectInput
                    label={"Epicenter"}
                    name="epicenter"
                    required={true}
                    value={formik.values.epicenter}
                    multiple={false}
                    onBlur={formik.handleBlur}
                    options={epicenterOptions}
                    error={formik.touched.epicenter && formik.errors.epicenter}
                    onChange={(event) => {
                      formik.setFieldValue("epicenter", event.target.value);
                    }}
                  />
                </div>

                <div className="col-md-6">
                  <div className="form_field_wrapper">
                    <label>
                      Number of Buckets<span style={{ color: "red" }}>*</span>
                    </label>
                    <TextField
                      type="number"
                      inputProps={{ min: 1 }}
                      name="number"
                      value={formik.values.number}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      placeholder="Enter quantity"
                      size="small"
                      fullWidth
                    />
                    {formik.touched.number && formik.errors.number && (
                      <span style={{ color: "red" }}>
                        {formik.errors.number}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal_footer">
              <button
                type="button"
                onClick={() => {
                  formik.resetForm();
                  onClose();
                }}
                className="btn btn-border"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                {editData ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default AddBucketModal;
